import { render, staticRenderFns } from "./agam_AppHeader.vue?vue&type=template&id=cfff4090&"
import script from "./agam_AppHeader.vue?vue&type=script&lang=js&"
export * from "./agam_AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./agam_AppHeader.vue?vue&type=style&index=0&id=cfff4090&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports